import { useTranslation } from 'react-i18next';
import { usePausedConsultations } from 'hooks/usePausedConsultations';
import { PausedConsultationsPanel } from './PausedConsultationsPanel';
import { Empty, Section } from './PausedConsultations.styles';

interface PausedConsultationsProps {
  medatixxPatientId?: string;
}

export const PausedConsultations = ({ medatixxPatientId }: PausedConsultationsProps) => {
  const { t } = useTranslation();
  const { consultations, isError } = usePausedConsultations(
    medatixxPatientId ? { medatixxPatientId } : undefined
  );

  const copy = medatixxPatientId
    ? {
        heading: t('patientOverview.pausedConsultations.title', { count: consultations.length }),
        loadError: t('patientOverview.pausedConsultations.loadError'),
      }
    : {
        heading: t('home.pausedConsultations.heading', { count: consultations.length }),
        loadError: t('home.pausedConsultations.loadError'),
      };

  const loadError = isError && <Empty role="alert">{copy.loadError}</Empty>;

  if (!consultations.length) {
    return loadError ? <Section data-ph-no-autocapture>{loadError}</Section> : null;
  }

  return (
    <Section data-ph-no-autocapture>
      <PausedConsultationsPanel
        label={copy.heading}
        consultations={consultations}
        showPatient={!medatixxPatientId}
      />
      {loadError}
    </Section>
  );
};
